import React, { useState } from "react";
import GetInTouch from "../../components/GetInTouch.js";
import VoipSolContact from "../../components/VoipSolContact.js";
import { Helmet } from "react-helmet-async";

const pointsData = [
  {
    title: "Automated Campaigns",
    content:
      "With voice and SMS broadcasting, you can automate your marketing and communication campaigns, sending pre-recorded messages or text alerts on specific dates and times. This helps to save time while ensuring consistent messaging across all channels.",
  },
  {
    title: "Personalized Messaging",
    content:
      "Voice and SMS broadcasting systems allow for personalized messages, addressing recipients by name or customizing content based on their preferences. This enhances customer experience and engagement, making the communication feel more tailored and relevant.",
  },
  {
    title: "Cost-Effective Communication",
    content:
      "Broadcasting solutions are an affordable way to communicate with large audiences. Compared to traditional advertising or in-person communication, voice and SMS broadcasting provide a cost-effective solution for businesses to reach out to customers without breaking the bank.",
  },
  {
    title: "Emergency Alerts and Notifications",
    content:
      "Voice/SMS broadcasting is ideal for sending emergency alerts, notifications, or important updates in real-time. Whether it’s for safety warnings, service disruptions, or critical announcements, broadcasting ensures timely and reliable communication during emergencies.",
  },
  {
    title: "Scalable for Any Business Size",
    content:
      "Whether you're a small business or a large corporation, a voice/SMS broadcasting system can scale to meet your needs. It can handle a growing number of contacts and messages, ensuring that your business can efficiently communicate with customers as it expands.",
  },
];

const SmsBroadcastingSystem = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Boost your business reach with India’s Best Voice & SMS Broadcasting Services. Deliver instant alerts, promotions & updates to your audience effortlessly!"
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="Best Voice & SMS Broadcasting service Provider in India | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/sms-broadcasting-system"
        />
        <meta
          property="og:description"
          content="Boost your business reach with India’s Best Voice & SMS Broadcasting Services. Deliver instant alerts, promotions & updates to your audience effortlessly!"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Best Voice & SMS Broadcasting service Provider in India | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Boost your business reach with India’s Best Voice & SMS Broadcasting Services. Deliver instant alerts, promotions & updates to your audience effortlessly!"
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link
          rel="canonical"
          href="https://ayanshtechnology.com/sms-broadcasting-system"
        />
        <title>
          Best Voice & SMS Broadcasting service Provider in India | Ayanshtech Solutions
        </title>
      </Helmet>
      <div className=" flex flex-col items-center justify-center mb-6 p-6">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-4 ">
          <div className="md:w-2/3 space-y-6 p-4">
            <h1 className="sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mt-10">
              Enterprise Voice/SMS Broadcasting Solutions
            </h1>
            <p className="text-gray-700 text-base lg:text-xl">
              Voice and SMS broadcasting play a crucial role in industries such
              as healthcare, education, IT, hospitality, telecom, and more.
              Broadcasting software is essential for delivering messages to a
              large number of users. Due to its accessibility and wide reach,
              SMS/Voice broadcasting software has become increasingly popular in
              the market.
            </p>
            <p className="text-gray-700 text-base lg:text-xl">
              Voice/SMS broadcasting solutions are highly effective for
              delivering important notifications quickly and efficiently. A
              multi-tenant broadcasting system offers a direct and timely way to
              engage with customers and audiences. Ayanshtech offers a
              customized SMS/Voice broadcasting solution with third-party API
              integration capabilities to ensure seamless, cost-efficient, and
              hassle-free operation.
            </p>
          </div>

          <VoipSolContact />
        </div>

        <div className="rounded-3xl">
          <div className="text-center mb-5 mt-5">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              Key Features of Ayanshtech Voice/SMS Broadcasting Solution
            </h2>
            <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
              Expand your reach and connect with more customers through our
              automated, flexible broadcasting solution.
            </p>
          </div>

          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="flex items-center space-x-4">
                <img
                  src="\assets\icons\techIcons\icon1.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <p className="text-lg">
                  Seamless integration of multiple IVR scripts
                </p>
              </div>

              <div className="flex items-center space-x-4">
                <img
                  src="\assets\icons\techIcons\icon2.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <p className="text-lg">Personalized messaging capability</p>
              </div>

              <div className="flex items-center space-x-4">
                <img
                  src="\assets\icons\techIcons\icon3.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <p className="text-lg">Automatic redial function</p>
              </div>

              <div className="flex items-center space-x-4">
                <img
                  src="\assets\icons\techIcons\icon4.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <p className="text-lg">Efficient call report notifications</p>
              </div>

              <div className="flex items-center space-x-4">
                <img
                  src="\assets\icons\techIcons\icon5.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <p className="text-lg">Easy import of contact lists</p>
              </div>

              <div className="flex items-center space-x-4">
                <img
                  src="\assets\icons\techIcons\icon6.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <p className="text-lg">
                  Throttle simultaneous calls effectively
                </p>
              </div>

              <div className="flex items-center space-x-4">
                <img
                  src="\assets\icons\techIcons\icon7.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <p className="text-lg">
                  Web-based call detail reports for ease of access
                </p>
              </div>

              <div className="flex items-center space-x-4">
                <img
                  src="\assets\icons\techIcons\icon8.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <p className="text-lg">
                  DNC and opt-out support for compliance
                </p>
              </div>

              <div className="flex items-center space-x-4">
                <img
                  src="\assets\icons\techIcons\icon9.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <p className="text-lg">
                  Answering machine detection for accurate response
                </p>
              </div>

              <div className="flex items-center space-x-4">
                <img
                  src="\assets\icons\techIcons\icon10.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <p className="text-lg">
                  Automated bulk SMS/Voice calls for effective communication
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Maximize Your Business Potential with Voice/SMS Broadcasting
            Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Stay ahead of the competition by fostering seamless communication
            with your team in real-time.
          </p>
        </div>

        <div className=" ">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/2 p-4">
              <img
                src="/assets/images/headerSection/voiceSms.png"
                alt="Voice & SMS Broadcasting Services"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon11.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Gain immediate feedback and user responses through various
                    telephone and mobile key options.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon12.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Reach a larger customer base at a lower cost, boosting your
                    business scalability.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon13.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Effortlessly create, schedule, and send automated voice and
                    SMS messages to your clients and suppliers.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon14.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Integrated with third-party tools in real-time for enhanced
                    call and SMS analysis.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon15.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Personalize your messages to add a unique touch and engage
                    your customers effectively.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-4">
          <div className="text-center mb-10 mt-10 ">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              Voice/SMS Broadcasting Solution
            </h2>
            <p className="sm:text-base md:text-lg lg:text-lg text-gray-600 mt-4 max-w-6xl mx-auto">
              If you're looking to impact multiple users at once, the Voice
              Messaging with Multi-Tenant Broadcasting Solution is ideal. It
              offers a secure, encrypted platform for delivering high-quality,
              reliable broadcasting campaigns—something every Voice/SMS
              broadcasting service aims for.
            </p>
          </div>

          <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 max-w-7xl mx-auto mb-20">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Manage and run multiple campaigns simultaneously
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Reconnect with customers who missed your call and safeguard
                  your leads
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Convert text into speech</p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon18.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Schedule campaigns based on specific days, times, and contacts
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon19.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Receive automated performance reports</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-green-50 p-4 mb-12 sm:mb-16 rounded-3xl">
          {/* Title Section */}
          <h2 className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6">
            Tailored Voice and SMS Broadcasting Services
          </h2>
          <p className="text-center text-base sm:text-lg md:text-xl text-gray-700 mb-8">
            Launch your campaign or project effectively with a broadcasting
            service designed to meet your business needs. Voice and SMS
            broadcasting solutions address numerous challenges, ensuring
            seamless communication and outreach.
          </p>

          {/* Navigation Bar */}
          <div className="flex justify-center flex-wrap gap-6 sm:gap-8 mb-4">
            {pointsData.map((point, index) => (
              <button
                key={index}
                className={`text-base sm:text-lg font-medium ${
                  activeIndex === index
                    ? "text-blue-600 underline"
                    : "text-gray-900"
                }`}
                onClick={() => setActiveIndex(index)}
              >
                {point.title}
              </button>
            ))}
          </div>

          {/* Content Section */}
          <div className="text-center max-w-5xl mx-auto p-4 border-gray-300">
            <p className="text-base sm:text-lg md:text-xl text-gray-600 mt-4">
              {pointsData[activeIndex].content}
            </p>
          </div>
        </div>

        <div className="text-center mb-16 mt-5 ">
          <h2 className="sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800">
            Why Choose Ayanshtech as Your Partner for Voice/SMS Broadcasting
            Solution Development
          </h2>
          <p className="sm:text-base md:text-lg lg:text-lg text-gray-600 mt-4 max-w-6xl mx-auto">
            Voice/SMS broadcasting has become increasingly popular in recent
            years. At Ayanshtech, we integrate this cutting-edge technology into
            your applications, ensuring long-term relevance. Our fully
            customizable Voice/SMS broadcasting solutions are designed for
            businesses of all sizes, offering advanced automated software that
            caters to both small and large enterprises. We provide robust,
            web-based solutions that eliminate the need for hardware changes
            when working with different Voice/Text Broadcasting Service
            providers. Our Multi-Tenant Broadcasting Solutions are ideal for
            inbound marketing, helping generate leads that can be converted. As
            a Voice Broadcasting Software Development company, we also offer
            seamless third-party API integrations for smooth, cost-effective
            operations.
          </p>
        </div>

        <GetInTouch />
      </div>
    </>
  );
};

export default SmsBroadcastingSystem;
